/* jjs-a11y.js: JJ Shine ADA fixes (WCAG 2.1 AA, axe-core 4.10.2) for two parts of Shopify's Horizon theme. Oct 15 2026 (Jordan:
   "do the footer and accessibility stuff"). Loaded on every page from layout/theme.liquid; does nothing where the parts are absent.
   1. Product-card photo sliders (collection pages, search): Horizon makes each card's photo strip a scroll box but takes it out of the
      Tab order (tabindex="-1"), so a keyboard user cannot reach or scroll it (axe: scrollable-region-focusable). Strips with more than
      one photo go back in the Tab order, named "<product> photos". The product page's own gallery is not touched.
   2. Collection filter row (computer): Horizon's overflow-list puts each filter straight into a list with no list item around it
      (axe: list). Each filter is marked as a list item.
   Cards and filters are redrawn when a shopper filters or sorts, so both fixes run again on any change to the page.
   Undo: 01-Shopify/footer-a11y-oct15/push_a11y.py --undo --go */
(function () {
  function cards(root) {
    var strips = root.querySelectorAll('[ref="cardGalleryLink"] slideshow-slides');
    for (var i = 0; i < strips.length; i++) {
      var s = strips[i];
      if (s.getAttribute('tabindex') === '0' || s.querySelectorAll('slideshow-slide').length < 2) continue;
      var link = s.closest('[ref="cardGalleryLink"]');
      var name = (link && link.getAttribute('aria-label')) || 'Product';
      s.setAttribute('tabindex', '0');
      s.setAttribute('role', 'group');
      s.setAttribute('aria-label', name + ' photos');
    }
  }
  function filters(root) {
    var lists = root.querySelectorAll('overflow-list');
    for (var i = 0; i < lists.length; i++) {
      var kids = lists[i].children;
      for (var k = 0; k < kids.length; k++) {
        var el = kids[k], tag = el.tagName;
        if (tag === 'TEMPLATE' || tag === 'SCRIPT' || tag === 'STYLE' || tag === 'LI' || el.getAttribute('role') === 'listitem') continue;
        el.setAttribute('role', 'listitem');
      }
    }
  }
  var queued = false;
  function run() { queued = false; cards(document); filters(document); }
  function later() { if (!queued) { queued = true; (window.requestAnimationFrame || setTimeout)(run); } }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  if (window.MutationObserver) new MutationObserver(later).observe(document.documentElement, { childList: true, subtree: true });
})();
